module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var theme = {};
//
// Spacer
//
theme.spacer = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56, 64, 72, 80, 96, 112, 128, 256];

//
// Colors
//
// TODO
// - Add HSL variations (to use in theme.button.secondary/ghost)
// - Add status colors
//
theme.colors = {
  black: '#1d1e1f',
  white: '#fff',
  primary: {
    '050': '#f1f9f9',
    100: '#e3f6f2',
    200: '#b8e5e3',
    300: '#60C5B7',
    500: '#0c7d84',
    700: '#035257',
    900: '#013a3e'
  },
  secondary: {
    100: '#fbf8f3',
    300: '#fff3ca',
    500: '#fad250',
    700: '#f5a83f',
    900: '#de6900'
  },
  gray: {
    opaque: {
      '050': '#f5f6f8',
      100: '#eef0f3',
      200: '#dde1e7',
      300: '#c9cfd6',
      400: '#b1b8c1',
      500: '#959da8',
      600: '#7e8691',
      700: '#59616d',
      800: '#424a54',
      900: '#2a2f35'
    },
    transparent: {
      '050': 'hsla(212, 19%, 28%, 0.05)',
      100: 'hsla(212, 19%, 28%, 0.10)',
      200: 'hsla(212, 19%, 28%, 0.15)',
      300: 'hsla(212, 19%, 28%, 0.20)',
      400: 'hsla(212, 19%, 28%, 0.30)',
      500: 'hsla(212, 19%, 28%, 0.40)',
      600: 'hsla(212, 19%, 28%, 0.50)',
      700: 'hsla(212, 31%, 13%, 0.50)',
      800: 'hsla(212, 31%, 13%, 0.65)',
      900: 'hsla(212, 31%, 13%, 0.85)'
    }
  }
};
theme.colors.bg = {
  white: theme.colors.white,
  sand: theme.colors.secondary['100'],
  hint: theme.colors.primary['500'],
  error: '#f6e3e3',
  errorInverse: '#d54242',
  warning: '#fef5dc',
  warningInverse: '#e2a900',
  success: '#ceebd9',
  successInverse: '#178574',
  info: '#e3ecf6',
  infoInverse: '#114e92',
  gray: '#F4F5F7',
  transparent: 'transparent'
};
theme.colors.border = {
  light: 'hsla(215, 18%, 78%, 0.2)',
  "default": 'hsla(215, 18%, 78%, 0.3)',
  dark: 'hsla(215, 18%, 78%, 0.5)',
  error: '#c73434',
  opaque: {
    light: '#f1f3f5',
    "default": '#eaedf0',
    darkOpaque: '#dde1e7'
  }
};
theme.colors.data = {
  "default": '#939faf',
  indestructible: '#21c198',
  fortified: '#5dddb2',
  sturdy: '#ffd871',
  tenuous: '#ff9b45',
  flimsy: '#ee5b69',
  none: '#aeb5bf'
};
theme.colors.status = {
  draft: 'todo',
  // TODO
  scheduled: 'todo',
  // TODO
  inProgress: 'todo',
  // TODO
  Completed: 'todo' // TODO
};

//
// Typography
//
// TODO
// - Add text.styles?
// - Add monospace stack
// - Add fontSize in rem
//
theme.text = {
  color: {
    100: '#a9aeb5',
    300: '#7b828a',
    500: '#565d66',
    700: '#34383c',
    900: '#1d1e1f',
    "default": '#565d66',
    link: theme.colors.primary['500'],
    linkHover: '#039ba1',
    white: '#fff',
    error: '#c73434',
    warning: '#cb7d20',
    success: '#15785f',
    info: '#1a518e'
  },
  fontFamily: {
    "default": 'Roboto, -apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif',
    mono: 'monospace' // TODO
  },
  fontSize: {
    // TODO: Add rem values?
    "default": '14px',
    xsm: '11px',
    sm: '13px',
    md: '14px',
    lg: '18px',
    xlg: '20px',
    xxlg: '24px',
    xxxlg: '32px',
    mega: '44px'
  },
  fontWeight: {
    light: '350',
    normal: '400',
    "default": '500',
    bold: '700',
    heavy: '800'
  },
  lineHeight: {
    reset: 1,
    "default": 1.33,
    // Default
    heading: 1.15
  },
  marginBottom: {
    "default": "".concat(theme.spacer[1], "px"),
    sm: "".concat(theme.spacer[1], "px"),
    md: "".concat(theme.spacer[2], "px"),
    lg: "".concat(theme.spacer[3], "px"),
    none: theme.spacer[0]
  }
};

//
// Icons
//
theme.icons = {
  size: {
    xxsm: '11px',
    xsm: '16px',
    sm: '20px',
    "default": '24px',
    // Default
    lg: '32px',
    xlg: '54px'
  },
  strokeWidth: {
    sm: 1,
    "default": 1.5,
    // Default
    lg: 2
  },
  color: {
    light: theme.text.color['100'],
    "default": theme.text.color['300'],
    dark: theme.text.color['500'],
    link: theme.text.color.link,
    linkHover: theme.text.color.linkHover
  }
};

//
// Z-Index
//
// TODO: Finalize scale
//
theme.zIndex = {
  contextMenu: '1000',
  popover: '3000',
  tooltip: '5000',
  modal: '7000',
  confirm: '8000',
  toast: '9000'
};

//
// Media-Query
//
theme.breakpoints = {
  // TODO: Rem here?
  large: 'todo',
  // Desktop
  medium: 'todo',
  // Tablet
  mediumPortrait: 'todo',
  // Tablet
  small: 'todo' // Phone
};

//
// Components
//
theme.article = {
  color: theme.colors.primary['700'],
  colorHover: theme.colors.primary['500']
};

// Input

theme.input = {
  height: {
    "default": '40px',
    large: '48px'
  },
  borderRadius: '5px',
  borderColor: theme.colors.border.dark,
  color: theme.text.color['700'],
  iconColor: theme.icons.color["default"],
  fontSize: {
    "default": theme.text.fontSize.md,
    large: theme.text.fontSize.lg
  },
  placeholder: {
    color: 'hsla(214, 7%, 22%, 0.5)'
  },
  hover: {
    borderColor: theme.colors.gray.transparent['400']
  },
  focus: {
    borderColor: theme.colors.primary['500'],
    boxShadow: "0 0 3px ".concat(theme.colors.primary['500'])
  },
  error: {
    borderColor: theme.text.color.error,
    boxShadow: "0 0 3px ".concat(theme.colors.primary['500'])
  },
  disabled: {
    borderColor: theme.colors.border.light,
    color: 'hsla(214, 7%, 22%, 0.5)'
  }
};
theme.button = {
  radius: '4px',
  backgroundColor: {
    "default": theme.colors.primary['500'],
    secondary: 'hsla(184, 83%, 28%, 0.15)',
    ghost: 'hsla(184, 83%, 28%, 0)'
  },
  color: {
    "default": theme.colors.white,
    secondary: theme.colors.primary['500'],
    ghost: theme.colors.primary['500']
  },
  fontSize: {
    xsm: theme.text.fontSize.xsm,
    sm: theme.text.fontSize.sm,
    "default": theme.text.fontSize.md,
    lg: theme.text.fontSize.lg
  },
  horizontalPadding: {
    xsm: '16px',
    sm: '20px',
    "default": '24px',
    lg: '24px'
  },
  fontWeight: {
    "default": theme.text.fontWeight.bold
  },
  height: {
    xsm: '24px',
    sm: '32px',
    "default": '40px',
    lg: '48px'
  },
  hover: {
    backgroundColor: {
      "default": theme.text.color.linkHover,
      secondary: 'hsla(184, 83%, 28%, 0.20)',
      ghost: 'hsla(184, 83%, 28%, 0)'
    },
    decoration: {
      "default": 'none',
      secondary: 'none',
      ghost: 'underline'
    }
  },
  active: {
    backgroundColor: {
      "default": '#068f93',
      secondary: 'hsla(184, 83%, 28%, 0.24)',
      ghost: 'hsla(184, 83%, 28%, 0.24)'
    }
  },
  focus: {
    backgroundColor: {
      "default": theme.text.color.linkHover,
      secondary: 'hsla(184, 83%, 28%, 0.20)',
      ghost: 'transparent'
    },
    shadow: {
      "default": '0 0 0 2px ' + theme.text.color.linkHover,
      secondary: '0 0 0 2px hsla(184, 83%, 28%, 0.20)',
      ghost: 'none'
    },
    outline: {
      "default": '#B8E5E3',
      secondary: '#60C5B7',
      ghost: '#60C5B7'
    },
    decoration: {
      "default": 'none',
      ghost: 'underline'
    }
  },
  disabled: {
    backgroundColor: {
      "default": '#AECCCE',
      secondary: 'hsla(184, 83%, 28%, 0.08)',
      ghost: 'hsla(184, 83%, 28%, 0.08)'
    },
    color: {
      "default": '#F1F9F9',
      secondary: 'hsla(184, 83%, 28%, 0.08)',
      ghost: 'hsla(184, 15%, 41%, 0.5)'
    }
  }
};
theme.buttonIcon = _objectSpread(_objectSpread({}, theme.button), {}, {
  height: {
    sm: '32px',
    "default": '40px',
    lg: '48px'
  },
  fontSize: {
    sm: theme.icons.size.sm,
    "default": theme.icons.size["default"],
    lg: theme.icons.size.lg
  },
  horizontalPadding: {
    sm: '4px',
    "default": '8px',
    lg: '12px'
  }
});
theme.card = {
  color: theme.text.color['900'],
  fontSize: theme.text.fontSize.md,
  header: {
    fontSize: theme.text.fontSize.md,
    bigFontSize: theme.text.fontSize.xxlg,
    boldFontWeight: theme.text.fontWeight.bold,
    fontWeight: theme.text.fontWeight.normal
  },
  backgroundColor: {
    "default": theme.colors.white,
    help: theme.colors.primary['050'],
    hint: theme.colors.bg.hint
  },
  margin: {
    "default": '20px',
    noMargin: '0px'
  },
  shadow: {
    "default": '0 0 0 1px ' + theme.colors.border["default"],
    hint: 'none'
  },
  borderRadius: '6px'
};
theme.tabs = {
  color: {
    "default": theme.text.color['500'],
    active: theme.colors.primary['500']
  },
  fontWeight: {
    "default": theme.text.fontWeight.normal,
    selected: theme.text.fontWeight["default"]
  },
  borderColor: theme.colors.border["default"],
  highlightColor: {
    "default": 'transparent',
    active: theme.colors.border["default"]
  },
  lineHeight: '26px',
  fontSize: theme.text.fontSize.md
};

//
// Chart color scale
//

theme.chart = {
  "default": {
    colors: [theme.colors.data.flimsy,
    // 0 -20
    theme.colors.data.tenuous,
    // 21 - 40
    theme.colors.data.sturdy,
    // 41 - 60
    theme.colors.data.fortified,
    // 61 - 80
    theme.colors.data.indestructible // 81 - 100
    ]
  }
};
// Breadcrumb component

theme.breadcrumb = {
  fontSize: theme.text.fontSize.sm,
  arrowColor: theme.icons.color['100'],
  currentPageColor: theme.text.color['300']
};

//
// Timeline block
//

theme.timeline = {
  label: {
    colors: {
      "default": theme.text.color['700'],
      isDone: theme.text.color['100']
    }
  }
};

// Avatar
theme.avatar = {
  colors: ['#EDA039', '#668CE5', '#86CC55', '#AC3ECF', '#384F84', '#DE4B6D', '#1CB696', '#7E8691'],
  fontSize: {
    xsm: '9px',
    sm: '10px',
    md: '14px',
    lg: '18px',
    xlg: '20px'
  },
  size: {
    xsm: '20px',
    sm: '24px',
    md: '32px',
    // (default size, used in sidebar profile and users list)
    lg: '40px',
    xlg: '48px' // (for homepage organization blog)
  }
};

// select input
theme.select = {
  "default": {
    borderColor: theme.colors.border.dark,
    color: theme.text.color['300'],
    iconColor: theme.icons.color["default"],
    borderRadius: '4px'
  },
  selected: {
    backgroundColor: '#277d83'
  },
  placeholder: {
    color: 'hsla(214, 7%, 22%, 0.5)' // TODO: Add hsl values of these
  },
  hover: {
    borderColor: theme.colors.gray.transparent['400'],
    iconColor: theme.icons.color.dark
  },
  focus: {
    borderColor: theme.colors.primary['500'],
    boxShadow: "0 0 3px hsla(".concat(theme.colors.primary['500'], ", 0.4)")
  },
  error: {
    borderColor: theme.colors.primary['500'],
    boxShadow: "0 0 3px hsla(".concat(theme.colors.primary['500'], ", 0.4)")
  },
  disabled: {
    borderColor: theme.colors.border.light,
    color: 'hsla(214, 7%, 22%, 0.5)'
  }
};
theme.messages = {
  color: {
    success: '#3c763d',
    successBorder: '#d0e9c6',
    successBackground: '#dff0d8',
    successOutline: '#0c7d84',
    white: '#fff',
    danger: '#a94442',
    dangerBorder: '#ebcccc',
    dangerBackground: '#f2dede',
    warning: '#8a6d3b',
    warningBorder: '#faf2cc',
    warningBackground: '#fcf8e3',
    info: '#31708f',
    infoBorder: '#bcdff1',
    infoBackground: '#d9edf7'
  }
};
theme.badge = {
  bg: {
    gray: '#EEF0F3',
    yellow: '#FFF3CA',
    green: '#E3F6F2',
    blue: '#E3ECF6',
    red: '#F6E3E3',
    white: '#FFFFFF',
    veryhigh: '#C62828',
    high: '#EF6C00',
    medium: '#FFB400',
    low: '#60AD5E',
    verylow: '#2E7D32',
    eventsgrey: '#EEE'
  },
  color: {
    gray: '#565D66',
    yellow: '#CB7D20',
    green: '#15785F',
    blue: '#1A518E',
    red: '#C73434',
    white: '#565d66',
    veryhigh: '#FFF',
    high: '#000',
    medium: '#000',
    low: '#FFF',
    verylow: '#FFF',
    eventsgrey: '#000'
  }
};
theme.badge.border = _objectSpread(_objectSpread({}, theme.badge.bg), {}, {
  white: '#C9CFD6'
});
/* harmony default export */ __webpack_exports__["a"] = (theme);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("styled-map");

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Display", function() { return Display; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H1", function() { return H1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H2", function() { return H2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H3", function() { return H3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H4", function() { return H4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H5", function() { return H5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Body", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Caption", function() { return Caption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Small", function() { return Small; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return A; });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var styled_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);



// Theme

var Display = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.p.withConfig({
  displayName: "Typography__Display",
  componentId: "ivw4se-0"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.mega, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.h1.withConfig({
  displayName: "Typography__H1",
  componentId: "ivw4se-1"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.xxxlg, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.h2.withConfig({
  displayName: "Typography__H2",
  componentId: "ivw4se-2"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.xxlg, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.h3.withConfig({
  displayName: "Typography__H3",
  componentId: "ivw4se-3"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.xlg, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.h4.withConfig({
  displayName: "Typography__H4",
  componentId: "ivw4se-4"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.lg, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var H5 = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.h5.withConfig({
  displayName: "Typography__H5",
  componentId: "ivw4se-5"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.md, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var Body = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.p.withConfig({
  displayName: "Typography__Body",
  componentId: "ivw4se-6"
})(["font-weight:", ";line-height:", ";margin-bottom:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('marginBottom', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.marginBottom), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.md, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.span.withConfig({
  displayName: "Typography__Text",
  componentId: "ivw4se-7"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.md, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var Caption = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.caption.withConfig({
  displayName: "Typography__Caption",
  componentId: "ivw4se-8"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.sm, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var Small = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.small.withConfig({
  displayName: "Typography__Small",
  componentId: "ivw4se-9"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.xsm, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
var A = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.a.withConfig({
  displayName: "Typography__A",
  componentId: "ivw4se-10"
})(["font-weight:", ";line-height:", ";color:", ";font-size:", ";margin:", ";padding:", ";-webkit-font-smoothing:antialiased;"], styled_map__WEBPACK_IMPORTED_MODULE_1___default()('fontWeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontWeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('lineHeight', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.lineHeight), styled_map__WEBPACK_IMPORTED_MODULE_1___default()('color', _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.color), _themes_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].text.fontSize.md, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
});
/* harmony default export */ __webpack_exports__["default"] = ({
  Display: Display,
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5,
  Body: Body,
  Text: Text,
  Caption: Caption,
  Small: Small,
  A: A
});

/***/ })
/******/ ]);